let self;
export class HttpInterceptor {
  public static $inject: Array<string> = ["$rootScope", "$q"];
  constructor(private $rootScope: ng.IRootScopeService, private $q: ng.IQService) {
    self = this;
  }
  public responseError(reject: any) {
    if (reject.status == 401) {
      self.$rootScope.$broadcast("userLogout");
    }
    return self.$q.reject(reject);
  }
}
